export default __webpack_public_path__ + "static/media/email.52ef21f1.svg";